import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Campaigns from './Campaigns';

export default class Snapshot extends Component {
  render() {
    const { campaigns, onPreview } = this.props;

    const wa = campaigns.filter(c => c.states.indexOf('wa') > -1);
    const nt = campaigns.filter(c => c.states.indexOf('nt') > -1);
    const sa = campaigns.filter(c => c.states.indexOf('sa') > -1);
    const qld = campaigns.filter(c => c.states.indexOf('qld') > -1);
    const nsw = campaigns.filter(c => c.states.indexOf('nsw') > -1);
    const vic = campaigns.filter(c => c.states.indexOf('vic') > -1);
    const tas = campaigns.filter(c => c.states.indexOf('tas') > -1);
    const act = campaigns.filter(c => c.states.indexOf('act') > -1);

    return (
      <Container>
        <Campaigns location="wa" campaigns={wa} onPreview={onPreview} />
        <Campaigns location="nt" campaigns={nt} onPreview={onPreview} />
        <Campaigns location="sa" campaigns={sa} onPreview={onPreview} />
        <Campaigns location="qld" campaigns={qld} onPreview={onPreview} />
        <Campaigns location="nsw" campaigns={nsw} onPreview={onPreview} />
        <Campaigns location="vic" campaigns={vic} onPreview={onPreview} />
        <Campaigns location="tas" campaigns={tas} onPreview={onPreview} />
        <Campaigns location="act" campaigns={act} onPreview={onPreview} />
        <Map
          url="/images/map-of-australia.png"
        />
      </Container>
    );
  }
}

Snapshot.propTypes = {
  campaigns: PropTypes.objectOf({
    states: PropTypes.array.isRequired,
  }).isRequired,
  onPreview: PropTypes.func.isRequired,
};

const Container = styled.div`
  position: relative;
  overflow: hidden;
  margin-top: 20px;
  height: 400px;
  padding: 20px;
  border: 2.5px solid #E2E5EF;
  border-radius: 3px;
`;

const Map = styled.div`
  background-image: url(${props => props.url});
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;




// WEBPACK FOOTER //
// ./client/Dashboard/components/Snapshot.js